import React, { Component, Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./datatable.jsx";
import { getAllOrdersApiRedux, getAllEmployeeRedux } from "../../actions/index";
import { Link } from "react-router-dom";
import UpdateRequestModal from "./updateRequestModal";
import {
  getSingleOrderApi,
  updateAllOrdersApi,
} from "../../firebase/firebase.utils.js";
import { get1688TrackingStatus } from "../../actions/get1688Data.js";
import { connect } from "react-redux";
import { Search } from "react-feather";
import { ClipLoader } from "react-spinners";
import { updateOrdersWithTrackingNoRedux } from "../../actions/index";
export class New extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      searchFor: "",
      toggleModal: true,
      toggleDeleteModal: true,
      order: null,
      loader1: false,
    };
  }

  componentDidMount = async () => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);

    // Format: YYYY-MM-DD (consistent everywhere)
    const endDate = today.toISOString().split("T")[0];
    const startDate = past.toISOString().split("T")[0];
    this.setState({
      customStart: startDate,
      customEnd: endDate,
    });
    this.props.getAllEmployeeRedux();
    if (this.props.match.params.orderStatus == "all-orders") {
      this.props.getAllOrdersApiRedux("", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "new") {
      this.props.getAllOrdersApiRedux("pending", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "purchased") {
      this.props.getAllOrdersApiRedux("Purchased", startDate, endDate);
    } else if (
      this.props.match.params.orderStatus === "received-in-warehouse"
    ) {
      this.props.getAllOrdersApiRedux(
        "Received in Warehouse",
        startDate,
        endDate
      );
    } else if (this.props.match.params.orderStatus === "ready-for-fly") {
      this.props.getAllOrdersApiRedux("Ready for fly", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "bangladesh-customs") {
      this.props.getAllOrdersApiRedux("Bangladesh customs", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "custom-released") {
      this.props.getAllOrdersApiRedux(
        "Bangladesh warehouse",
        startDate,
        endDate
      );
    } else if (this.props.match.params.orderStatus === "Paicart-warehouse") {
      this.props.getAllOrdersApiRedux("Paicart warehouse", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "delivered") {
      this.props.getAllOrdersApiRedux("Delivered", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "rejected") {
      this.props.getAllOrdersApiRedux("Reject", startDate, endDate);
    } else if (this.props.match.params.orderStatus === "picked-orders") {
      this.props.getAllOrdersApiRedux("Picked", startDate, endDate);
    }
  };

  componentWillReceiveProps = (nextProps) => {
    const today = new Date();
    const past = new Date();
    past.setDate(today.getDate() - 30);

    // Format: YYYY-MM-DD (consistent everywhere)
    const endDate = today.toISOString().split("T")[0];
    const startDate = past.toISOString().split("T")[0];

    if (
      this.props.match.params.orderStatus !== nextProps.match.params.orderStatus
    ) {
      this.setState({
        customStart: startDate,
        customEnd: endDate,
        searchFor: "",
        order1688: null,
      });
      if (nextProps.match.params.orderStatus === "all-orders") {
        this.props.getAllOrdersApiRedux("", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "new") {
        this.props.getAllOrdersApiRedux("pending", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "purchased") {
        this.props.getAllOrdersApiRedux("Purchased", startDate, endDate);
      } else if (
        nextProps.match.params.orderStatus === "received-in-warehouse"
      ) {
        this.props.getAllOrdersApiRedux(
          "Received in Warehouse",
          startDate,
          endDate
        );
      } else if (nextProps.match.params.orderStatus === "ready-for-fly") {
        this.props.getAllOrdersApiRedux("Ready for fly", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "bangladesh-customs") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh customs",
          startDate,
          endDate
        );
      } else if (nextProps.match.params.orderStatus === "bangladesh-customs") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh customs",
          startDate,
          endDate
        );
      } else if (nextProps.match.params.orderStatus === "custom-released") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh warehouse",
          startDate,
          endDate
        );
      } else if (nextProps.match.params.orderStatus === "Paicart-warehouse") {
        this.props.getAllOrdersApiRedux(
          "Paicart warehouse",
          startDate,
          endDate
        );
      } else if (nextProps.match.params.orderStatus === "delivered") {
        this.props.getAllOrdersApiRedux("Delivered", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "rejected") {
        this.props.getAllOrdersApiRedux("Reject", startDate, endDate);
      } else if (nextProps.match.params.orderStatus === "picked-orders") {
        this.props.getAllOrdersApiRedux("Picked", startDate, endDate);
      }
    }
  };

  startToggleModal = async (order) => {
    if (order == null) {
      this.setState({
        toggleModal: !this.state.toggleModal,
        order: null,
      });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        order,
      });
    }
  };

  handleSearchBarChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  applyRange = async () => {
    const { customStart, customEnd } = this.state;
    this.setState({
      order1688: null,
      searchFor: "",
    });
    let startDate = customStart;
    let endDate = customEnd;
    console.log(customStart);
    console.log(customEnd);
    if (customStart && customEnd) {
      if (this.props.match.params.orderStatus == "all-orders") {
        this.props.getAllOrdersApiRedux("", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "new") {
        this.props.getAllOrdersApiRedux("pending", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "purchased") {
        this.props.getAllOrdersApiRedux("Purchased", startDate, endDate);
      } else if (
        this.props.match.params.orderStatus === "received-in-warehouse"
      ) {
        this.props.getAllOrdersApiRedux(
          "Received in Warehouse",
          startDate,
          endDate
        );
      } else if (this.props.match.params.orderStatus === "ready-for-fly") {
        this.props.getAllOrdersApiRedux("Ready for fly", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "bangladesh-customs") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh customs",
          startDate,
          endDate
        );
      } else if (this.props.match.params.orderStatus === "custom-released") {
        this.props.getAllOrdersApiRedux(
          "Bangladesh warehouse",
          startDate,
          endDate
        );
      } else if (this.props.match.params.orderStatus === "Paicart-warehouse") {
        this.props.getAllOrdersApiRedux(
          "Paicart warehouse",
          startDate,
          endDate
        );
      } else if (this.props.match.params.orderStatus === "delivered") {
        this.props.getAllOrdersApiRedux("Delivered", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "rejected") {
        this.props.getAllOrdersApiRedux("Reject", startDate, endDate);
      } else if (this.props.match.params.orderStatus === "picked-orders") {
        this.props.getAllOrdersApiRedux("Picked", startDate, endDate);
      }
    }
  };

  handleSubmit2 = async (e) => {
    e.preventDefault();
    if (!this.state.searchFor) {
      alert("Order Id cant be empty.");
      return;
    }
    let order = await getSingleOrderApi(this.state.searchFor);
    if (order) {
      this.setState({
        order1688: order,
      });
    } else {
      alert("Sorry no order is found with this order Id");
    }
    console.log("handle submit 2 is getting called!");
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  getAllTrackingNo = async (orders) => {
    if (orders && orders.length > 0) {
      if (this.state.loader1) {
        return;
      }
      this.setState({
        loader1: true,
      });
      let newOrders = [];
      for (let i = 0; i < orders.length; i++) {
        const order = orders[i];
        let trackingArray = await get1688TrackingStatus(order.orderNumber);
        let trackingObj = trackingArray ? trackingArray[0] : null;

        console.log(trackingObj);
        if (trackingObj && trackingObj.logisticsBillNo) {
          newOrders.push({ ...order, trackingNo: trackingObj.logisticsBillNo });
        }
      }
      this.props.updateOrdersWithTrackingNoRedux(newOrders);

      this.setState({
        loader1: false,
      });
      console.log(newOrders);
    } else {
      alert("At least select one order to get 1688 Tracking No");
    }
  };

  render() {
    const { open, customStart, customEnd } = this.state;
    let { ordersApi } = this.props;
    let orders = [];
    let totalWeight = 0;
    let totalRmb = 0;
    let totalBdt = 0;
    let totalExpense = 0;
    let totalProfit = 0;

    if (ordersApi.length > 0) {
      if (this.props.match.params.orderStatus == "new") {
        orders = ordersApi.filter((order) => order.agentStatus !== "Picked");
        orders = orders.sort((a, b) => b.time - a.time);
      } else {
        orders = ordersApi.sort((a, b) => b.time - a.time);
      }
      orders.map((order) => {
        totalWeight += order.items[0].weight
          ? parseFloat(order.items[0].weight)
          : 0;
        if (
          order.creationTime1688 &&
          order.creationTime1688.totalSuccessAmount
        ) {
          totalRmb += parseFloat(order.creationTime1688.totalSuccessAmount);
          totalExpense += parseFloat(
            order.creationTime1688.totalSuccessAmount * order.exchangeRate
          )
            ? parseFloat(order.creationTime1688.totalSuccessAmount) *
              order.exchangeRate
            : 0;
        }
        totalBdt +=
          order.orderTotal +
          (order.localShipping ? parseFloat(order.localShipping) : 0);
      });
    }
    totalProfit = totalBdt - totalExpense;
    console.log(this.props);
    return (
      <Fragment>
        <UpdateRequestModal
          toggleModal={this.state.toggleModal}
          startToggleModal={this.startToggleModal}
          order={this.state.order}
        />

        <Breadcrumb
          title={this.props.match.params.orderStatus}
          parent="1688/tabao Orders"
        />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div
                  className="card-header"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <h5>{this.props.match.params.orderStatus} Orders</h5>
                  <div>
                    <button
                      onClick={() => {
                        let ordersWithOrderNumber = orders.filter(
                          (order) => order.orderNumber && !order.trackingNo
                        );
                        this.getAllTrackingNo(ordersWithOrderNumber);
                      }}
                      className="btn"
                      style={{ background: "cadetblue", color: "white" }}
                    >
                      {this.state.loader1 ? (
                        <div style={{ paddingLeft: 120, paddingRight: 120 }}>
                          <ClipLoader
                            color={"black"}
                            loading={this.state.loader1}
                            size={16}
                            aria-label="Loading Spinner"
                            data-testid="loader"
                          />
                        </div>
                      ) : (
                        "Get 1688 Tracking No"
                      )}
                    </button>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 10,
                    marginTop: 10,
                  }}
                >
                  {/* CUSTOM RANGE */}
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      padding: "10px",
                    }}
                  >
                    <div style={{ display: "flex", gap: 10 }}>
                      <input
                        type="date"
                        className="form-control"
                        name="customStart"
                        value={customStart}
                        onChange={this.handleChange}
                      />
                      <input
                        type="date"
                        className="form-control"
                        name="customEnd"
                        value={customEnd}
                        onChange={this.handleChange}
                        min={customStart}
                      />

                      <button
                        onClick={this.applyRange}
                        className="btn"
                        style={{ background: "black", color: "white" }}
                      >
                        Apply
                      </button>
                    </div>
                    <li
                      style={{
                        border: "1px solid gainsboro",
                        borderRadius: "5rem",
                        padding: "0px 20px",
                        background: "whitesmoke",
                        marginRight: "20px",
                      }}
                    >
                      <form
                        className="form-inline search-form"
                        onSubmit={this.handleSubmit2}
                      >
                        <div
                          // className="form-group"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-around",
                          }}
                        >
                          <input
                            className={
                              "form-control-plaintext " +
                              (this.state.searchbar ? "open" : "")
                            }
                            name="searchFor"
                            value={this.state.searchFor}
                            type="search"
                            placeholder="Search Order Id"
                            style={{ paddingLeft: 10 }}
                            onChange={this.handleSearchBarChange}
                          />
                          <span>
                            <Search
                              style={{
                                marginTop: "5px",
                                borderLeft: "1px solid gainsboro",
                                paddingLeft: "7px",
                                color: "gray",
                              }}
                              onClick={(e) => {
                                this.handleSubmit2(e);
                              }}
                            />
                          </span>
                        </div>
                      </form>
                    </li>
                  </div>

                  {/* APPLY BUTTON */}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    paddingLeft: 10,
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: 17,
                      marginBottom: 5,
                      color: "white",
                      background: "gray",
                      borderRadius: 5,
                      border: "2px solid gainsboro",
                      display: "inline-block",
                      padding: "2px 5px",
                    }}
                  >
                    Total Orders: {orders.length}
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: 17,
                      marginBottom: 5,
                      color: "white",
                      background: "skyblue",
                      borderRadius: 5,
                      border: "2px solid gainsboro",
                      display: "inline-block",
                      padding: "2px 5px",
                    }}
                  >
                    Total Weight: {parseFloat(totalWeight).toFixed(2)}Kg
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: 17,
                      marginBottom: 5,
                      color: "white",
                      background: "cadetblue",
                      borderRadius: 5,
                      border: "2px solid gainsboro",
                      display: "inline-block",
                      padding: "2px 5px",
                    }}
                  >
                    Total Rmb: ¥ {parseFloat(totalRmb).toFixed(2)}
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: 17,
                      marginBottom: 5,
                      color: "white",
                      background: "#9797f6",
                      borderRadius: 5,
                      border: "2px solid gainsboro",
                      display: "inline-block",
                      padding: "2px 5px",
                    }}
                  >
                    Total Bdt: Tk {parseFloat(totalBdt).toFixed(2)}
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: 17,
                      marginBottom: 5,
                      color: "white",
                      background: "#e98989",
                      borderRadius: 5,
                      border: "2px solid gainsboro",
                      display: "inline-block",
                      padding: "2px 5px",
                    }}
                  >
                    Total Expense: Tk {parseFloat(totalExpense).toFixed(2)}
                  </div>
                  <div
                    style={{
                      fontWeight: "bold",
                      fontSize: 17,
                      marginBottom: 5,
                      color: "white",
                      background: "#79b079",
                      borderRadius: 5,
                      border: "2px solid gainsboro",
                      display: "inline-block",
                      padding: "2px 5px",
                    }}
                  >
                    Total Profit: Tk {parseFloat(totalProfit).toFixed(2)}
                  </div>
                </div>
                <div className="card-body">
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      startDeleteToggleModal={this.startDeleteToggleModal}
                      history={this.props.history}
                      orderStatus={this.props.match.params.orderStatus}
                      multiSelectOption={false}
                      myData={
                        this.state.order1688 ? [this.state.order1688] : orders
                      }
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    ordersApi: state.orders.ordersApi,
  };
};

export default connect(mapStateToProps, {
  getAllOrdersApiRedux,
  getAllEmployeeRedux,
  updateOrdersWithTrackingNoRedux,
})(New);
